export default __webpack_public_path__ + "static/media/chess.a7ba105f.png";